import template from './riccardo-offer-detail.html.twig';

const { Criteria } = Shopware.Data;
const { Mixin } = Shopware;

export default {
    template,

    inject: ['repositoryFactory'],

    mixins: [Mixin.getByName('notification')],

    props: {
        offerId: { type: String, required: false, default: null },
    },

    data() {
        return {
            offer: null,
            isLoading: false,
            isSaveSuccessful: false,
        };
    },

    metaInfo() {
        return { title: this.$createTitle(this.offer?.name) };
    },

    computed: {
        offerRepository() {
            return this.repositoryFactory.create('riccardo_offer');
        },

        audienceOptions() {
            return ['customers', 'group', 'tag', 'all'].map((value) => ({
                value,
                label: this.$t(`riccardo-offer.detail.audience_${value}`),
            }));
        },

        promotionCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addFilter(Criteria.equals('useCodes', true));
            criteria.addSorting(Criteria.sort('name', 'ASC'));
            return criteria;
        },

        /** Zusammenfassung in Worten – so sieht man vor dem Speichern, was passiert */
        summary() {
            if (!this.offer) {
                return '';
            }

            const audience = {
                customers: 'nur die unten zugeordneten Kunden',
                group: 'alle Kunden der gewählten Kundengruppe',
                tag: 'alle Kunden mit dem gewählten Tag',
                all: 'alle angemeldeten Kunden',
            }[this.offer.audience] || '';

            const validity = this.offer.durationHours
                ? `Der Countdown startet beim ersten Anzeigen und läuft ${this.offer.durationHours} Stunden.`
                : (this.offer.endsAt
                    ? `Gilt bis ${new Date(this.offer.endsAt).toLocaleString('de-DE')}.`
                    : 'Ohne Frist – das Banner läuft, bis das Angebot abgeschaltet wird.');

            const code = this.offer.code ? `Code ${this.offer.code}` : 'ohne Code (nur Hinweis)';

            return `${code} für ${audience}. ${validity} Bei mehreren passenden Angeboten gewinnt die höhere Priorität (aktuell ${this.offer.priority ?? 0}).`;
        },
    },

    created() {
        this.loadOffer();
    },

    methods: {
        loadOffer() {
            if (!this.offerId) {
                this.offer = this.offerRepository.create();
                this.offer.active = true;
                this.offer.audience = 'customers';
                this.offer.priority = 0;
                this.offer.durationHours = 48;
                this.offer.linkPath = '/deals';
                return Promise.resolve();
            }

            this.isLoading = true;
            const criteria = new Criteria();
            criteria.addAssociation('customers');
            criteria.addAssociation('promotion');

            return this.offerRepository.get(this.offerId, Shopware.Context.api, criteria).then((offer) => {
                this.offer = offer;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        /** Code aus der gewählten Aktion übernehmen, damit beides zusammenpasst */
        onPromotionChange(promotionId, promotion) {
            if (promotion?.code) {
                this.offer.code = promotion.code;
            }
        },

        onSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;

            return this.offerRepository.save(this.offer).then(() => {
                this.isSaveSuccessful = true;
                this.createNotificationSuccess({ message: this.$t('riccardo-offer.detail.saveSuccess') });

                if (!this.offerId) {
                    this.$router.push({ name: 'riccardo.offer.detail', params: { id: this.offer.id } });
                    return Promise.resolve();
                }

                return this.loadOffer();
            }).catch((error) => {
                this.createNotificationError({
                    message: error?.response?.data?.errors?.[0]?.detail || this.$t('riccardo-offer.detail.saveError'),
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
};
